import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import { blogData } from "../utils/blogData";
import ScrollToTopButton from "./ScrollToTopButton";

const BlogDetailsPage = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const foundBlog = blogData.find((b) => b.id === parseInt(id));
    setBlog(foundBlog);
    window.scrollTo(0, 0);
  }, [id]);

  if (!blog) {
    return (
      <div className="py-5 mt-5 text-center">
        <Container>
          <h2>Blog Not Found</h2>
          <Link to="/blog" className="btn btn-primary mt-3">Back to Blogs</Link>
        </Container>
      </div>
    );
  }

  return (
    <>
      <div className="mt-header">
        <section className="blog-details-section py-5">
          <Container>
            <Row className="mb-4">
              <Col lg={8}>
                <h1 className="display-5 fw-bold mb-3">{blog.title}</h1>
                <div className="d-flex align-items-center mb-4 text-muted">
                  <i className="far fa-calendar-alt me-2 text-primary"></i>
                  <span>{blog.date}</span>
                  <span className="mx-3 text-light">|</span>
                  <i className="far fa-user me-2 text-primary"></i>
                  <span>By {blog.author}</span>
                </div>
              </Col>
            </Row>
            <Row>
            <Col lg={8}>
              <div className="blog-content-wrapper bg-white p-4 p-md-5 shadow-sm rounded">
                <img 
                  src={blog.image} 
                  alt={blog.title} 
                  className="img-fluid rounded mb-4 w-100 shadow"
                  style={{ maxHeight: "500px", objectFit: "cover" }}
                />
                
                <div className="blog-full-content" dangerouslySetInnerHTML={{ __html: blog.content }}>
                </div>

                <hr className="my-5" />

                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                  <div className="share-post">
                    <span className="fw-bold me-3">Share this post:</span>
                    <a href="#" className="text-primary me-3 text-decoration-none"><i className="fab fa-facebook-f"></i></a>
                    <a href="#" className="text-info me-3 text-decoration-none"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-primary text-decoration-none"><i className="fab fa-linkedin-in"></i></a>
                  </div>
                  <Link to="/blog" className="btn btn-outline-primary rounded-pill px-4">
                    <i className="fas fa-arrow-left me-2"></i> Back to Blogs
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={4}>
              <div className="blog-sidebar mt-5 mt-lg-0">
                <Card className="border-0 shadow-sm mb-4">
                  <Card.Body>
                    <h5 className="fw-bold mb-3 border-bottom pb-2">Recent Posts</h5>
                    {blogData.filter(b => b.id !== blog.id).slice(0, 3).map(recent => (
                      <div key={recent.id} className="d-flex mb-3 align-items-center">
                        <img 
                          src={recent.image} 
                          alt={recent.title} 
                          className="rounded"
                          style={{ width: "80px", height: "60px", objectFit: "cover" }}
                        />
                        <div className="ms-3">
                          <Link to={`/blog-details/${recent.id}`} className="text-dark text-decoration-none small fw-bold d-block mb-1 line-clamp-2">
                            {recent.title}
                          </Link>
                          <span className="text-muted small">{recent.date}</span>
                        </div>
                      </div>
                    ))}
                  </Card.Body>
                </Card>

                <Card className="border-0 shadow-sm secondary-content bg-primary text-white text-center p-4">
                  <Card.Body>
                    <h4 className="fw-bold mb-3">Have a project in mind?</h4>
                    <p className="mb-4">Let's build something amazing together.</p>
                    <Link to="/contactus" className="btn btn-light rounded-pill px-4 fw-bold">Contact Us</Link>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>

    <ScrollToTopButton />
  </>
  );
};

export default BlogDetailsPage;
